import React from "react";

import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { GroupedInclusionPatient } from "@/models/GroupedInclusionModel.ts";
import { TextToast } from "@/uiKit/atoms/Toast.tsx";
import { PatientAcceptedTelemonitoringCard } from "@/uiKit/molecules/InclusionCenter/PatientAcceptedTelemonitoringCard.tsx";
import { PatientCreation } from "@/uiKit/organisms/PatientCreationAndRenewal/PatientCreation.tsx";

export type GroupedInclusionAcceptedSuggestionProps = {
  suggestion: GroupedInclusionPatient;
  className?: string;
};

export const GroupedInclusionAcceptedSuggestion: React.FC<GroupedInclusionAcceptedSuggestionProps> = ({
  suggestion,
  className,
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isPatientCreationOpened, setPatientCreationOpened] = React.useState(false);

  return (
    <>
      <PatientAcceptedTelemonitoringCard
        patientFirstName={suggestion.firstName}
        patientLastName={suggestion.lastName}
        patientId={suggestion.id}
        onStartTelemonitoring={() => setPatientCreationOpened(true)}
        className={className}
      />
      <PatientCreation
        id="patient-creation-from-grouped-inclusion"
        open={isPatientCreationOpened}
        defaultValues={{
          givenName: suggestion.firstName,
          familyName: suggestion.lastName,
          email: suggestion.email,
          phone: suggestion.phoneNumber,
        }}
        groupedInclusion={suggestion}
        onClose={() => setPatientCreationOpened(false)}
        onSubmit={(patientId: string) => {
          setPatientCreationOpened(false);
          TextToast.success(t("diabetesForms.patientCreated"), t("diabetesForms.clickToView"), {
            onClick: () =>
              navigate({
                to: `/patients/${patientId}`,
              }),
          });
        }}
      />
    </>
  );
};
